import { takeLatest, put, call } from 'redux-saga/effects';

import { OPERATION_DEFINITION_CATEGORIES } from 'modules/opDefs';
import quoteItemService from 'modules/quotes/quoteItems/data/service';
import { types as modalTypes } from 'modules/quotes/quoteItems/modals/Operation/data/actions';

import { types } from './actions';
import { realTimeMaterialPricing } from './actions';

export default function* root() {
  yield takeLatest(modalTypes.OPEN_OPERATION_MODAL, watchOpenOperationModal);
  yield takeLatest(
    types.REALTIME_MATERIAL_PRICING_REQUEST,
    watchRealTimeMaterialPricingRequest,
  );
}

function* watchOpenOperationModal(action) {
  const { payload } = action;
  const { operation } = payload;
  if (operation.category === OPERATION_DEFINITION_CATEGORIES.MATERIAL) {
    const isRound = (operation.taskSet || []).includes('lathe');
    yield put(realTimeMaterialPricing.request(operation.componentId, isRound));
  }
}

function* watchRealTimeMaterialPricingRequest(action) {
  try {
    const { payload } = action;
    const { componentId, isRound } = payload;
    const response = yield call(
      quoteItemService.quantities.getRealTimeMaterialPricing,
      componentId,
      isRound ? { isRound } : {},
    );
    yield put(realTimeMaterialPricing.success(response));
  } catch (error) {
    console.error(error);
    yield put(realTimeMaterialPricing.error());
  }
}
